<template>
  <div>
    <el-table :data="reportList" style="width: 100%" border>
      <el-table-column prop="System" label="系统来源" align="center" />
      <el-table-column prop="FunctionName" label="数据来源" align="center" />
      <el-table-column prop="StartTime" label="开始时间" align="center" />
      <el-table-column prop="EndTime" label="结束时间" align="center" />
      <el-table-column prop="CreateTime" label="创建时间" align="center" />
      <el-table-column label="具体数据" align="center">
        <template #default="{ row }">
          <el-button @click="handleDetail(row)" size="small">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange2"
      @current-change="handleCurrentChange2"
      :current-page="reportPageParams.page"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="reportTotal"
      background
      style="margin-top: 10px"
    ></el-pagination>

    <el-dialog title="数据详情" :visible.sync="detailVisible" width="100%" class="mydialog">
      <el-table :data="detailList.Data" style="width: 100%" border>
        <el-table-column :prop="col.DataName" :label="col.Name" align="center" v-for="(col, idx) in detailList.ColumnList" :key="idx" width="200px" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import dataCenterApi from '../../api/dataCenterNav';
export default {
  data() {
    return {
      reportList: [],
      detailVisible: false,
      reportPageParams: {
        page: 1,
        rows: 10,
        key: ''
      },
      detailList: [],
      reportTotal: 0
    };
  },
  methods: {
    handleDetail(row) {
      if (!row.DataInfo) return this.$message.error('暂无更多数据');
      this.detailVisible = true;
      let dataInfo = JSON.parse(row.DataInfo);
      this.detailList = dataInfo;
    },
    async getReportPageList() {
      let res = await dataCenterApi.reportPageList(this.reportPageParams);
      console.log(res);
      this.reportList = res.data.Data.rows;
      this.reportTotal = res.data.Data.total;
    },
    handleSizeChange2(limit) {
      this.reportPageParams.rows = limit;
      this.getReportPageList();
    },
    handleCurrentChange2(page) {
      this.reportPageParams.page = page;
      this.getReportPageList();
    }
  },
  created() {
    this.getReportPageList();
  }
};
</script>

<style lang="scss" scoped>
.mydialog {
  :deep(.el-dialog) {
    height: 100vh;
    margin-top: 0 !important;
  }

  :deep(.el-table__body-wrapper) {
    height: 70vh;
    overflow: auto;
  }
}
</style>
